// react
import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// mui
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// recoil
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';

// components
import { Gateway, ErrorBody } from './components';

// api
import { IsAuth } from './api';

// theme
import { WhiteTheme } from '@goldblack/client-comps';

import { handleResponse, handleError, authencated } from './api/internal/api-error';

import ErrorBoundary from './error/error-boundary';
import localForage from 'localforage';

// state
import { LocalStorageState, TransientState } from './storage';

// client-shared
import { api } from '@goldblack/client-api';
import { comp, ErrorPopup, InfoPopup, WarningPopup, SuccessPopup } from '@goldblack/client-comps';
import { storage } from '@goldblack/client-storage';
import { config } from '@goldblack/client-config';

// css
import './app.css';

let _isAuthCalled = false;

// local forage
localForage.config({
    driver: localForage.INDEXEDDB,
    name: 'loise',
    version: 1.0,
    storeName: 'cache',
});

function MyRoutes() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route exact path='/' element={<Gateway />} />
                <Route path='*' element={<Navigate to='/' />} />
            </Routes>
        </BrowserRouter>
    );
}

export default function App() {
    const [loading, setLoading] = useState(true);

    // initialize client-shared
    const tvalue = useRecoilValue(TransientState);
    const tset = useSetRecoilState(TransientState);
    const treset = useResetRecoilState(TransientState);
    const lvalue = useRecoilValue(LocalStorageState);
    const lset = useSetRecoilState(LocalStorageState);
    const lreset = useResetRecoilState(LocalStorageState);

    storage.load({ tvalue, tset, treset, lvalue, lset, lreset });

    useEffect(() => {
        if (_isAuthCalled) return;
        _isAuthCalled = true;

        const configs = config.load('account');
        api.load({
            handleResponse,
            handleError,
            authencated,
            transience: storage.transience,
            baseURL: import.meta.env.VITE_API_BASE_URL || '',
        });
        comp.load({ transience: storage.transience });

        const userSession = storage.transience.getValue('userSession');
        if (!userSession) {
            IsAuth(configs.meta.hash, setLoading);
        }
        return () => {};
    }, []);

    return (
        <ThemeProvider theme={WhiteTheme}>
            <CssBaseline />
            <ErrorBoundary fallback={ErrorBody}>{!loading ? <MyRoutes /> : <></>}</ErrorBoundary>

            {/*===== global popups =====*/}
            <ErrorPopup />
            <WarningPopup />
            <InfoPopup />
            <SuccessPopup />
        </ThemeProvider>
    );
}
